import React from 'react';
import TeamMember from './TeamMember';
import TeamPattern from './TeamPattern';

const teamMembers = [
  {
    name: "Benny",
    role: "Grundlægger",
    description: "Manden, der i 1999 besluttede, at dansk pølsekultur trængte til et løft – og et sted at få en god omgang rør og hygge. Det blev mere end bare en pølsevogn, det blev et mødested for dem, der ikke er bange for en stor en med det hele. Bennys gik bort 29 marts 2022",
    image: "https://i.ibb.co/wptM0vq/Benny.png"
  },
  {
    name: "Brian",
    role: "Ejer & Pølsemester",
    description: "Siden 2013 har Brian taget faderens pølsestafet videre med samme kærlighed for godt håndværk og lækre råvarer – og nu ruller han rundt i København med foodtruck og catering, så alle kan få en bid af festen!",
    image: "https://i.ibb.co/K5ngRyN/Brian.png"
  }
];

export default function TeamSection() {
  return (
    <section id="team" className="relative py-24 bg-[#FDF6E9] overflow-hidden">
      {/* Background Pattern */}
      <TeamPattern />
      
      {/* Top Fade */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white to-transparent z-10" />
      
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 retro-text">
            Mød Holdet
          </h2>
          <p className="text-xl text-gray-600">
            To generationer, én passion: Danmarks bedste pølser
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12">
          {teamMembers.map((member, index) => (
            <TeamMember key={index} {...member} index={index} />
          ))}
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
}